// Dependecies
import React, { useEffect } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { withTranslation } from 'react-i18next';
import { useForm, Controller } from 'react-hook-form';
// Hook
import Popup from 'reactjs-popup';
import UsePopUpDriverUpdate from '../../hooks/UsePopUpDriverUpdate';
import useCity from '../../hooks/useCities';

// helpers
import { patternEmail } from '../../helpers';

// Images
import closeIcon from '../../../sass/images/icons/close.svg';
import alert from '../../../sass/images/alert/alert.svg';

function PopUpDriverEdit({ isBlocked, t, close, infoDriver = [], success }) {
  const dataDriver = infoDriver || null;
  const { register, handleSubmit, errors, control, setValue, formState } = useForm({
    mode: 'onChange',
  });
  const { isValid } = formState;
  const { submit, messageErrorEmail, messageErrorId } = UsePopUpDriverUpdate(success);
  const { citiesAll } = useCity();

  useEffect(() => {
    // get user and set form fields
    const fields = ['status'];
    fields.forEach((field) => setValue(field, infoDriver[field]));
  }, []);

  return (
    <>
      <Popup open={isBlocked}>
        <div className="modal-design" id="modal-design" />
        <div className="modal-driver">
          <div className="modal-content-driver">
            <button type="button" className="close" onClick={close}>
              <img className="modal-img-close" src={closeIcon} alt={t('alt:close')} />
            </button>
            <div className="modal-heading-box driver">
              <form onSubmit={handleSubmit((data) => submit(data, dataDriver.id))} id="formUser">
                <Row className="no-gutters">
                  <Col xs={12} sm={12} className="block-job driver">
                    <label htmlFor="name" className="col-form-label">
                      {t('name')}*
                    </label>
                    <input
                      name="name"
                      type="text"
                      ref={register({
                        value: true,
                        required: true,
                      })}
                      className="form-control"
                      defaultValue={dataDriver.name || ''}
                    />
                    {errors.name && (
                      <div className="error_input">
                        <p>
                          <img src={alert} alt={t('alt:notification')} />
                          {t('alert:required-field')}
                        </p>
                      </div>
                    )}
                  </Col>
                  <Col xs={12} sm={12} className="block-job driver">
                    <label htmlFor="last_name" className="col-form-label">
                      {t('last_name')}*
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="last_name"
                      ref={register({
                        value: true,
                        required: true,
                      })}
                      defaultValue={dataDriver.last_name || ''}
                    />
                    {errors.last_name && (
                      <div className="error_input">
                        <p>
                          <img src={alert} alt={t('alt:notification')} />
                          {t('alert:required-field')}
                        </p>
                      </div>
                    )}
                  </Col>
                  <Col xs={12} sm={12} className="block-job driver">
                    <label htmlFor="identification" className="col-form-label">
                      {t('identification')}*
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="identification"
                      ref={register({
                        value: true,
                        required: true,
                      })}
                      defaultValue={dataDriver.identification || ''}
                    />
                    {errors.identification && (
                      <div className="error_input">
                        <p>
                          <img src={alert} alt={t('alt:notification')} />
                          {t('alert:required-field')}
                        </p>
                      </div>
                    )}
                  </Col>
                  <Col xs={12} sm={12} className="block-job driver">
                    <label htmlFor="email" className="col-form-label">
                      {t('email')}*
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="email"
                      ref={register({
                        value: true,
                        required: false,
                        pattern: { value: patternEmail, message: t('login:invalid') },
                      })}
                      defaultValue={dataDriver.email || ''}
                    />
                    {errors.email && (
                      <div className="error_input">
                        <img src={alert} alt={t('alt:notification')} />
                        {errors.email.message ? (
                          <p>{errors.email.message}</p>
                        ) : (
                          <p>{t('alert:required-field')}</p>
                        )}
                      </div>
                    )}
                  </Col>
                  <Col xs={12} sm={12} className="block-job driver">
                    <label htmlFor="phone" className="col-form-label">
                      {t('phone')}*
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="phone"
                      ref={register({
                        value: true,
                        required: true,
                        maxLength: {
                          value: 10,
                          message: t('register:max-10'),
                        },
                        minLength: {
                          value: 10,
                          message: t('register:min-10'),
                        },
                        pattern: {
                          value: /[0-9]$/,
                          message: t('alert:number'),
                        },
                      })}
                      defaultValue={dataDriver.phone || ''}
                    />
                    {errors.phone && (
                      <div className="error_input">
                        <p>
                          <img src={alert} alt={t('alt:notification')} />
                          {errors.phone.message ? (
                            <>{errors.phone.message}</>
                          ) : (
                            <>{t('alert:required-field')}</>
                          )}
                        </p>
                      </div>
                    )}
                  </Col>
                  {dataDriver.cities ? (
                    <Col xs={12} sm={12} md={12} className="block-job driver multiple">
                      <label htmlFor="city" className="col-form-label">
                        {t('city')}*
                      </label>{' '}
                      <Controller
                        className="form-control"
                        id="city"
                        name="city"
                        control={control}
                        defaultValue={dataDriver.cities}
                        render={({ onChange, value }) => (
                          <Select
                            placeholder=""
                            autoFocus={false}
                            isMulti
                            isClearable={false}
                            id="city"
                            name="city"
                            className="form-control edit"
                            classNamePrefix="multiple"
                            options={citiesAll}
                            value={[...value]}
                            onChange={onChange}
                          />
                        )}
                        rules={{ required: true }}
                      />
                      {errors.city && (
                        <div className="error_input">
                          <p>
                            <img src={alert} alt={t('alt:notification')} />
                            {errors.city.message ? (
                              <>{errors.city.message}</>
                            ) : (
                              <>{t('alert:required-field')}</>
                            )}
                          </p>
                        </div>
                      )}
                    </Col>
                  ) : (
                    ''
                  )}

                  <Col xs={12} sm={12} className="block-job driver">
                    <label htmlFor="status" className="col-form-label">
                      {t('status')}*
                    </label>
                    <select
                      defaultValue={dataDriver.status || ''}
                      className="form-control"
                      id="status"
                      name="status"
                      ref={register({
                        value: true,
                        required: true,
                      })}
                    >
                      <option value="6">{t('statusAct')}</option>
                      <option value="7">{t('statusIna')}</option>
                    </select>
                    {errors.status && (
                      <div className="error_input">
                        <p>
                          <img src={alert} alt={t('alt:notification')} />
                          {t('alert:required-field')}
                        </p>
                      </div>
                    )}
                  </Col>
                  {messageErrorEmail && (
                    <div className="error_input alert">
                      <p>
                        <img src={alert} alt={t('alt:notification')} />
                        {t('errorEmail')}
                      </p>
                    </div>
                  )}
                  {messageErrorId && (
                    <div className="error_input alert">
                      <p>
                        <img src={alert} alt={t('alt:notification')} />
                        {t('errorId')}
                      </p>
                    </div>
                  )}
                  <button
                    id="BtnSubmit"
                    type="submit"
                    className={` btn btn-primary button-job driver ${isValid ? '' : 'disabled'}`}
                  >
                    {t('updateDriver')}
                  </button>
                </Row>
              </form>
            </div>
          </div>
        </div>
      </Popup>
    </>
  );
}

PopUpDriverEdit.propTypes = {
  isBlocked: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
  infoDriver: PropTypes.node,
  success: PropTypes.func.isRequired,
};

PopUpDriverEdit.defaultProps = {
  infoDriver: [],
};

export default withTranslation('driverRegistration')(PopUpDriverEdit);
